import React from 'react';
import '../../ElectricFuelPages/ElectricFuel.scss';

const UsersTableView = ({ userData }: { userData: any }) => {
  const statusBadge = () => {
    if (userData?.active_status === 5)
      return <span className="tag is-success is-light">Active</span>;
    return <span className="tag is-danger is-light">Inactive</span>;
  };

  const rolesLabel = userData?.roles
    ? userData.roles.map((r: any) => r.label).join(', ')
    : '—';

  const fields = [
    { label: 'Name', value: userData?.ename, icon: 'fa fa-user' },
    { label: 'Email', value: userData?.emailid, icon: 'fa fa-envelope' },
    { label: 'Mobile', value: userData?.mobile_no, icon: 'fa fa-phone' },
    { label: 'Role', value: rolesLabel, icon: 'fa fa-shield' },
  ];

  return (
    <div className="p-4">
      <div className="detail-view-avatar">
        <i className="fa fa-user-circle"></i>
      </div>
      <div className="columns is-multiline">
        {fields.map((field, idx) => (
          <div className="column is-6" key={idx}>
            <div className="detail-view-field">
              <p className="detail-view-label">
                <i className={`${field.icon} mr-1`}></i> {field.label}
              </p>
              <p className="detail-view-value">{field.value || '—'}</p>
            </div>
          </div>
        ))}
        <div className="column is-6">
          <div className="detail-view-field">
            <p className="detail-view-label">
              <i className="fa fa-toggle-on mr-1"></i> Status
            </p>
            <p className="detail-view-value">{statusBadge()}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsersTableView;
